import React from "react";
import { FlexRowSB } from "../../constant/CustomeStyle";
import SideBarLeft from "../../constant/Topbar/SideBarLeft";
import Topbar from "../../constant/Topbar/Topbar";

const FirstLayout = ({ children }) => {
  return (
    // <div>
    //   <main>{children}</main>
    // </div>
    <div
      style={{
        minHeight: 834,
        background: "#EFF3F4",
      }}
    >
      <Topbar />
      <ContainerBox children={children} />
    </div>
  );
};

const ContainerBox = ({ children }) => (
  <FlexRowSB>
    <SideBarLeft />

    <main>{children}</main>
  </FlexRowSB>
);

export default FirstLayout;
